export default {
  isAwsInfoExist: false,
  sendEmailStatus: false,
  loadingData: false,
  adminNextPageKey: '',
  adminReportNextPageKey: '',
  nextArchivedPageKey: '',
  adminWorkloadList: [],
  adminReportWorkloadList: [],
  masterWorkloads: [],
  adminListHeaders: [
    {
      text: 'Actions',
      value: ''
    },
    {
      sortable: true,
      text: 'Opportunity ID',
      value: 'SFDC_Id'
    },


    // WORKLOAD DATA
    {
      sortable: true,
      text: 'Workload Title',
      value: 'Workload_Title'
    },
    {
      sortable: true,
      text: 'Customer Name',
      value: 'Customer_Name'
    },
    {
      sortable: true,
      text: 'OppReg Req Date',
      value: 'OppReg_Req_Date'
    },
    {
      sortable: true,
      text: 'Workload Status',
      value: 'Workload_Status'
    },
    {
      sortable: true,
      text: 'Workload Type',
      value: 'Workload_type'
    },
    {
      sortable: true,
      text: 'Campaign Name',
      value: 'Campaign_Name'
    },
    {
      sortable: true,
      text: 'Submitter',
      value: 'Requestor_Email'
    },
    {
      sortable: true,
      text: 'AWS ACE ID',
      value: 'AWS_ACE_ID'
    },
    {
      sortable: true,
      text: 'Global Registered',
      value: 'Global_Registered'
    }
  ],
  changeFrom: null,
  changeTo: null,
  questionnaireChangeTo: null,
  questionnaireChangeFrom: null,
  logsShown: false,
  loadingLogs: false,
  loadingRequest: false,
  logRecords: [],
  logHeaders: [
    {
      sortable: true,
      text: 'ID',
      value: 'Log_Id',
      align: 'left'
    },
    {
      sortable: true,
      text: 'Action',
      value: 'Action',
      align: 'left'
    },
    {
      sortable: false,
      text: 'User',
      value: 'User',
      align: 'left'
    },
    {
      sortable: true,
      text: 'Change From',
      value: 'Change_From',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Change To',
      value: 'Change_To',
      align: 'left'
    },
    {
      sortable: true,
      text: 'Created At',
      value: 'Create_Date',
      align: 'left'
    }
  ],
  workloads: [],
  workload: {
    workloadType: null,
    notifyWorkloadStatusUpdate: false,
    questionaire: {
      Project_Id: null,
      OppReg_Id: null,
      Registration_Id: null,
      Workload_Title: null,
      DXC_Managed_Services: null,
      Projected_Monthly_Spend: null,
      Workload_Description: null,
    },
    wlqa: {
      Id: null,
      Project_Id: null,
      WL_Q1A: null,
      WL_Q2A: null,
      WL_Q3A: null,
      WL_Q4A: null,
      WL_Q5A: null,
      WL_Q6A: null,
      Attested_By: null,
      DXC_Services: null,
      WL_Q7A: '[]',
      WL_Q8A: null,
      WL_Q9A: null,
      WL_Q10A: null
    },
    opportunity: {
      Opportunity_Id: null,
      SFDC_Oppty_Name: null,
      SFDC_Sales_Stage: null,
      SignDate: null,
      OpportunityTotalValueUSD: null,
      ESRegion: null,
      Customer_Name: null,
      Country: null,
      PrimaryESPracticeName: null,
      OpportunityDescription: null,
      OpportunityStatus: null,
      IndustryVertical: null,
      ContractLength: null,
      Client_ID: null,
      AWS_ACE_ID: null
    },

    account: {
      Client_ID: null,
      Customer_Name: null,
      Customer_Region: null,
      Customer_URL: null,
      Customer_Address: null,
      Customer_City: null,
      Customer_State: null,
      Customer_PC: null,
      Industry: null
    },

    contact: {
      Contact_First_Name: null,
      Contact_Last_Name: null,
      Contact_Phone: null,
      Contact_Email: null,
      Contact_Title: null,
      Contact_FullName: null
    },
    header: {
      OppReg_Id: null,
      Requestor_Id: null,
      Opportunity_Id: null,
      Ext_Account_Id: null,
      OppReg_Header_Notes: null,
      OppReg_Status: null,
      Country: null,
      RFI_RFP: null
    },
    requestor: {
      Requestor_First_Name: null,
      Requestor_Last_Name: null,
      Requestor_Phone: null,
      Requestor_Email: null
    },
    aws: {
      OppReg_Status: '',
      AWS_SalesRep_Name: '',
      AWS_SalesRep_eMail: '',
      AWS_Approval: '',
      AWS_Notes: '',
      AWS_Date_Approved: '',
      AWS_Use_Case: '',
      AWS_Sub_Use_Case: '',
      AWS_Partner_Primary: '',
      AWS_Reseller: '',
      AWS_Competitive_Tracking: '',
      AWS_Other_Competitors: '',
      AWSInfo_id: ''

    },

    opportunityNumber: '',
    opportunityNumberExistError: false,
    opportunityNumberExistErrorMessages: [],
    opportunityNumberExistSuccess: false,
    opportunityNumberExistSuccessMessages: [],
    opportunityNumberExistLoading: false,
    opportunityNumberExist: false,

    uploads: [{
      Doc_Id: null,
      AWS_Info_Id: null,
      File: null,
      FileName: null,
      FileType: null,
      Upload_TS: null,
      Uploaded_By: null
    }]
  },

  newWorkload: {
    workloadType: null,
    oppproject:{
      Project_Id: null,
      OppReg_Id: null,
      Registration_Id: null,
      Contact_Id: null,
      Requestor_Id: null,
      SFDC_Id: null,
      Workload_Title: null,
      Campaign_Name: null,
      VMware_Workload: null,
      VMware_License: null,
      VMware_Cust_Deploy: null,
      Workload_type: null, 
      PPA_Attestation: null,
      Root_Access: null,
      DXC_Managed_Services: null,
      SaaS: null,
      Initiate_Account_Flag: null,
      Workload_Services_Storage: null,
      Workload_Services_Database: null,
      Workload_Services_App_services: null,
      Workload_Services_Compute: null,
      Workload_Services_Network: null,
      Projected_Monthly_Spend: null,
      WL_Overall_Objective: null,
      WL_Scope_Bounderies: null,
      WL_App_Transformed: null,
      WL_Next_Pursuit: null,
      OppReg_Project_Notes: null,
      OppReg_Req_Date: null,
      Workload_Status: null,
      Workload_Description: null,
      Date_Created: null,
      Date_Updated: null,
      P_Offering_Agreed: null,
      WL_Q5: null,
      WL_Q6: null,
      Closed_Ind: null,
      Q1: null,
      Q2: null,
      Q3: null,
      Q4: null,
      Q5: null,
      Q6: null,
      Q7: null,
      Q8: null,
      Q9: null,
      Attested_By_Date: null,
      Attested_By_Email: null,
      Attested_By_Title: null,
      Attested_By_Manager: null
    },
    wlqa: {
      Id: null,
      Project_Id: null,
      WL_Q1A: null,
      WL_Q2A: null,
      WL_Q3A: null,
      WL_Q4A: null,
      WL_Q5A: null,
      WL_Q6A: null,
      Attested_By: null,
      DXC_Services: null,
      WL_Q7A: '[]',
      WL_Q8A: null,
      WL_Q9A: null,
      WL_Q10A: null
    }
  },

  allOppregProjBySalesForceId: [{
    Customer_Name: null,
    Contact_First_Name: null,
    Contact_Last_Name: null,
    Contact_Title: null,
    Contact_Phone: null,
    Contact_Email: null,
    AWS_ACCOUNT_ID: null,
    Workload_Title: null,
    Workload_Description: null,
    Additional_Comments: null,
    Projected_Monthly_Spend: null,
    Vertical_Industry: null,
    Other_Industry: null,
    Country: null,
    Customer_State: null,
    Customer_Address: null,
    Customer_City: null,
    Customer_PC: null,
    Customer_URL: null,
    Use_Case_Default_Migration: null,
    Sub_Use_Case: null,
    SignDate: null,
    Partner_Primary_Need_from_AWS_default_Technical_consultation: null,
    Is_this_for_Resell: null,
    
    Competitive_Tracking: null,
    Other_Competitors: null,
    AWS_SalesRep_Name: null,
    AWS_Field_Engagement: null,
    Campaign_Name: null,
    Contract_Vehicle: null,
    Is_this_for_Marketplace: null,
    Marketing_Development_Funded: null
  }],
  allWorkloadByOppregId: [],
  allWorkloads: [{
    Customer_Name: null,
    Contact_First_Name: null,
    Contact_Last_Name: null,
    Contact_Title: null,
    Contact_Phone: null,
    Contact_Email: null,
    AWS_ACCOUNT_ID: null,
    Workload_Title: null,
    Workload_Description: null,
    Additional_Comments: null,
    Projected_Monthly_Spend: null,
    Vertical_Industry: null,
    Other_Industry: null,
    Country: null,
    Customer_State: null,
    Customer_Address: null,
    Customer_City: null,
    Customer_PC: null,
    Customer_URL: null,
    Use_Case_Default_Migration: null,
    Sub_Use_Case: null,
    SignDate: null,
    Partner_Primary_Need_from_AWS_default_Technical_consultation: null,
    Is_this_for_Resell: null,
    Competitive_Tracking: null,
    Other_Competitors: null,
    AWS_SalesRep_Name: null,
    AWS_Field_Engagement: null,
    Campaign_Name: null,
    Contract_Vehicle: null,
    Is_this_for_Marketplace: null,
    Marketing_Development_Funded: null
  }],
  allOppregData: [{
    Customer_Name: null,
    Contact_First_Name: null,
    Contact_Last_Name: null,
    Contact_Title: null,
    Contact_Phone: null,
    Contact_Email: null,
    AWS_ACCOUNT_ID: null,
    Workload_Title: null,
    Workload_Description: null,
    Additional_Comments: null,
    Projected_Monthly_Spend: null,
    Vertical_Industry: null,
    Other_Industry: null,
    Country: null,
    Customer_State: null,
    Customer_Address: null,
    Customer_City: null,
    Customer_PC: null,
    Customer_URL: null,
    Use_Case_Default_Migration: null,
    Sub_Use_Case: null,
    SignDate: null,
    Partner_Primary_Need_from_AWS_default_Technical_consultation: null,
    Is_this_for_Resell: null,
    Competitive_Tracking: null,
    Other_Competitors: null,
    AWS_SalesRep_Name: null,
    AWS_Field_Engagement: null,
    Campaign_Name: null,
    Contract_Vehicle: null,
    Is_this_for_Marketplace: null,
    Marketing_Development_Funded: null

  }],
  // State for revised AGAM 512
  exportWorkloads: [],
  exportWorkload: [{
    // Customer_Company_Name: null,
    // Customer_First_Name: null,
    // Customer_Last_Name: null,
    // Customer_Title: null,
    // Customer_Phone: null,
    // Customer_Email: null,
    // AWS_ACCOUNT_ID: null,
    // Partner_Project_Title: null,
    // Project_Description: null,
    // Additional_Comments: null,
    // Expected_Monthly_AWS_Revenue: null,
    // Industry_Vertical: null,
    // Industry_Other: null,
    // Country: null,
    // State_Province: null,
    // Street_Address: null,
    // City: null,
    // Postal_Code: null,
    // Website: null,
    // Use_Case: null,
    // Sub_Use_Case: null,
    // Target_Close_Date: null,
    // Partne_Primary_Need_from_AWS: null,
    // Is_this_for_Resell: null,
    // Competitive_Tracking: null,
    // Other_Competitors: null,
    // Primary_Sales_Contact: null,
    // AWS_Field_Engagement: null,
    // Campaign_Name: null,
    // Contract_Vehicle: null,
    // Is_this_for_Marketplace: null,
    // Marketing_Development_Funded: null

    Customer_Company_Name: null,
    Partner_Project_Title: null,
    Project_Description: null,
    Expected_Monthly_AWS_Revenue: null,
    Industry_Vertical: null,
    Country: null,
    Postal_Code: null,
    Website: null,
    Use_Case: null,
    Target_Close_Date: null,
    Partner_Primary_Need_from_AWS: null,
    Customer_First_Name: null,
    Customer_Last_Name: null,
    Customer_Title: null,
    Customer_Phone: null,
    Customer_Email: null,
    AWS_Account_ID: null,
    Additional_Comments: null,
    Other_Industry: null,
    State_Province: null,
    Street_Address: null,
    City: null,
    Sub_Use_Case: null,
    Is_this_for_Resell: null,
    Competitive_Tracking: null,
    Other_Competitors: null,
    Campaign_Name: null,
    Contract_Vehicle: null,
    Is_this_for_Marketplace: null,
    Marketing_Development_Funded: null,
    Did_an_AWS_Account_Rep_for_this_opportunity: null,
    Primary_Sales_Contact_First_Name: null,
    Primary_Sales_Contact_Last_Name: null,
    Primary_Sales_Contact_Phone: null,
    Primary_Sales_Contact_Email: null,
    Primary_Contact_Title: null,
    Does_this_opportunity_include_managed_services: null
    

  }],

  //NEW AWS EXTRACT FORMAT
  newExportWorkloads:[],
  newExportWorkload: [{
    Customer_Company_Name: null,
    Partner_Project_Title: null,
    Project_Description: null, 
    Expected_Monthly_AWS_Revenue: null, 
    Industry_Vertical: null, 
    Country: null,
    Postal_Code: null,
    Website: null,
    Use_Case: null,
    Target_Close_Date: null,
    Partner_Primary: null, 
    Delivery_Model: null,
    Customer_First_Name: null, 
    Customer_Last_Name: null,
    Customer_Title: null,
    Customer_Phone: null,
    Customer_Email: null,
    AWS_Account_ID: null,
    Additional_Comments: null,
    Industry_Other: null,
    State_Province: null, 
    Street_Address: null,
    City: null,
    Sub_Use_Case: null, 
    Competitive_Tracking: null, 
    Other_Competitors: null,
    Campaign_Name:null,
    Contract_Vehicle: null,
    Public_Tender_Solicitation_No: null,
    Is_this_for_Marketplace: null, 
    Marketing_Development_Funded: null,
    Did_an_AWS_Account_Rep: null,
    Primary_Sales_Contact_First_Name: null, 
    Primary_Sales_Contact_Last_Name: null,
    Primary_Sales_Contact_Phone: null,
    Primary_Sales_Contact_Email: null,
    Primary_Contact_Title: null,
    If_Other_please_describe_your_needs: null,
    Partner_CRM_Unique_Identifier: null,
    Consent_to_Limit_Visibility: null
  }],




  // state to identify workloads that's been included in EXPORT WORKLOADS
  isExtractChecked: false,
  checkedWorkloads: [],
  checkedWorkload: [{
    Project_Id: null,
    Registration_Id: null,
    isChecked: null
  }],
  uploadHeaders: [
    {
      sortable: true,
      text: 'File Name',
      value: 'FileName'
    },
    {
      sortable: true,
      text: 'Uploaded',
      value: 'Upload_TS'
    },
    {
      sortable: true,
      text: 'Uploaded By',
      value: 'Uploaded_By'
    }
  ],
  uploadList: [
    {
      file_name: 'file1',
      uploaded_date: '05-03-2009',
      uploaded_by: 'Monique Clariza'
    },
    {
      file_name: 'file2',
      uploaded_date: '04-22-2019',
      uploaded_by: 'Candice Salvatore'
    },
    {
      file_name: 'file3',
      uploaded_date: '06-22-2019',
      uploaded_by: 'Katrina Ramos'
    },
    {
      file_name: 'file4',
      uploaded_date: '07-28-2019',
      uploaded_by: 'Rachelle Alinsod'
    }

  ],
  dialogEmail: {
    show: false,
    loading: false,
    type: 'alert',
    persistent: false,
    sendLabel: 'Send Email',
    cancelLabel: 'Cancel',
    sendHandler: null,
    sendHandlerLoading: false,
    cancelHandler: null,
    Contact_Email: '',
    AWS_SalesRep_Name: '',
    AWS_SalesRep_eMail: '',
    OppReg_Status: '',
    cc: null,
    emailSubjectType: null,
    email_template: null,
    templateEmail: null,
    showResponse: false,
    responseMessage: null,
    responseType: null,
    Notes: '',
    note_post: null,
    Project_Id: null,
    emailRecipients: [],
  },
  // GENERAL REPORTING
  workloadList: [],
  workloadLists1: [],
  report:{
    DXC_Opportunity_Region: '',
    DXC_Opportunity_Company_Name: '',
    Partner_Project_Title: '',
    Project_Description: '',
    Expected_Monthly_AWS_Revenue: '',
    DXC_Industry: '',
    Customer_Country: '',
    Customer_State: '',
    Customer_Street_Address: '',
    Customer_City: '',
    Customer_Postal_Code: '',
    Customer_Primary_Website_URL: '',
    Target_Close_Date: '',
    Saas:'',
    Attestation:'',
    Approved_Tier:'',
    Date_Approved:'',
    SFDC_Status:'',
    Notes:'',
    Creator_Name:'',
    Creator_Email:'',
    Date_Created:''
  },
  workloadHeaders: [
    {
      sortable: false,
      text: 'Actions',
      value: 'Actions'
    },
    {
      sortable: true,
      text: 'Registration ID',
      value: 'Registration_Id'
    },
    {
      sortable: true,
      text: 'Submit Date',
      value: 'OppReg_Req_Date'
    },
    {
      sortable: true,
      text: 'Workload Status',
      value: 'Workload_Status'
    },
    {
      sortable: true,
      text: 'Contact Email',
      value: 'Contact_Email'
    }
  ],
  newOppRegistration: {
    withError: false,
    searching: false,
    opportunityId: null,
    opportunityFound: false,
    showWorkloadForm: false,
    inProgress: false,
    reportInProgress: false,
    type: 'new'
  },
  OppRegRequestList: [],
  OppRegRequestHeaders: [
    {
      sortable: true,
      text: 'Project Id',
      value: 'Project_Id'
    },
    {
      sortable: true,
      text: 'OppReg Id',
      value: 'OppReg_Id'
    },
    {
      sortable: true,
      text: 'AWS ACE ID',
      value: 'AWS_ACE_ID'
    },
    {
      sortable: true,
      text: 'Customer Name',
      value: 'Customer_Name'
    },
    {
      sortable: true,
      text: 'Region',
      value: 'Customer_Region'
    },
    {
      sortable: true,
      text: 'Opportunity Name',
      value: 'SFDC_Oppty_Name'
    },
    {
      text: 'Workload Title',
      value: 'Workload_Title'
    },
    {
      sortable: true,
      text: 'Workload Status',
      value: 'Workload_Status'
    },
    {
      sortable: true,
      text: 'Workload Type',
      value: 'Workload_type'
    },
    {
      sortable: true,
      text: 'Campaign Name',
      value: 'Campaign_Name'
    },
    {
      sortable: true,
      text: 'Submitter',
      value: 'Requestor_Email'
    },
    {
      sortable: true,
      text: 'SignDate',
      value: 'SignDate'
    },
    {
      sortable: true,
      text: 'Public Sector',
      value: 'Public_Sector'
    },
    {
      sortable: true,
      text: 'Advisory Services',
      value: 'Advisory_Services'
    },
    {
      sortable: true,
      text: 'Attestation',
      value: 'Attestation'
    },
    {
      sortable: true,
      text: 'Date Created',
      value: 'Date_Created'
    },
  ],
  OppRegExpandedHeaders: [
    {
      sortable: true,
      text: 'Project Id',
      value: 'Project_Id'
    },
    {
      sortable: true,
      text: 'OppReg Id',
      value: 'OppReg_Id'
    },
    {
      sortable: true,
      text: 'AWS ACE ID',
      value: 'AWS_ACE_ID'
    },
    {
      sortable: true,
      text: 'Customer Name',
      value: 'Customer_Name'
    },
    {
      text: 'Workload Title',
      value: 'Workload_Title'
    },
    {
      sortable: true,
      text: 'Region',
      value: 'Customer_Region'
    },
    {
      sortable: true,
      text: 'SignDate',
      value: 'SignDate'
    },
    {
      sortable: true,
      text: 'Opportunity Name',
      value: 'SFDC_Oppty_Name'
    },
    {
      sortable: true,
      text: 'Projected Monthly Spend',
      value: 'Projected_Monthly_Spend'
    },
    {
      sortable: true,
      text: 'Workload Status',
      value: 'Workload_Status'
    },
    {
      sortable: true,
      text: 'Workload Type',
      value: 'Workload_type'
    },
    {
      sortable: true,
      text: 'Campaign Name',
      value: 'Campaign_Name'
    },
    {
      sortable: true,
      text: 'Submitter',
      value: 'Requestor_Email'
    },
    {
      sortable: true,
      text: 'Public Sector',
      value: 'Public_Sector'
    },
    {
      sortable: true,
      text: 'Advisory Services',
      value: 'Advisory_Services'
    },
    {
      sortable: true,
      text: 'Attestation',
      value: 'Attestation'
    },
    {
      sortable: true,
      text: 'Date Created',
      value: 'Date_Created'
    }
  ],
  OppRegMasterHeaders: [
    {
      sortable: true,
      text: 'Project Id',
      value: 'Project_Id'
    },
    {
      sortable: true,
      text: 'OppReg Id',
      value: 'OppReg_Id'
    },
    {
      sortable: true,
      text: 'AWS ACE ID',
      value: 'AWS_ACE_ID'
    },
    {
      sortable: true,
      text: 'Opportunity Name',
      value: 'SFDC_Oppty_Name'
    },
    {
      sortable: true,
      text: 'Workload Title',
      value: 'Workload_Title'
    },
    {
      sortable: true,
      text: 'Workload Status',
      value: 'Workload_Status'
    },
    {
      sortable: true,
      text: 'Workload Type',
      value: 'Workload_type'
    },
    {
      sortable: true,
      text: 'Campaign Name',
      value: 'Campaign_Name'
    },
    {
      sortable: true,
      text: 'Submitter',
      value: 'Requestor_Email'
    },
    {
      sortable: true,
      text: 'Customer Name',
      value: 'Customer_Name'
    },
    {
      sortable: true,
      text: 'Customer Region',
      value: 'Customer_Region'
    },
    {
      sortable: true,
      text: 'Country',
      value: 'Country'
    },
    {
      sortable: true,
      text: 'Closing Date',
      value: 'Closing_Date'
    },
    {
      sortable: true,
      text: 'AWS Charge',
      value: 'AWS_Charge'
    },
    {
      sortable: true,
      text: 'AWS Monthly Est Rev',
      value: 'AWS_Est_Rev'
    },
    {
      sortable: true,
      text: 'Public Sector',
      value: 'Public_Sector'
    },
    {
      sortable: true,
      text: 'Advisory Services',
      value: 'Advisory_Services'
    },
    {
      sortable: true,
      text: 'Attestation',
      value: 'Attestation'
    },
    {
      sortable: true,
      text: 'Date Created',
      value: 'Date_Created'
    },
    {
      sortable: true,
      text: 'Date Updated',
      value: 'Date_Updated'
    },
    {
      sortable: true,
      text: 'Id',
      value: 'Id'
    },
    {
      sortable: true,
      text: 'Sent Date',
      value: 'Sent_Date'
    },
    {
      sortable: true,
      text: 'Success',
      value: 'Success'
    },
    {
      sortable: true,
      text: 'Module',
      value: 'Module'
    },
    {
      sortable: true,
      text: 'Sender',
      value: 'Sender'
    },
    {
      sortable: true,
      text: 'Recipient',
      value: 'Recipient'
    },
    {
      sortable: true,
      text: 'Cc',
      value: 'Cc'
    },
    {
      sortable: true,
      text: 'Subject',
      value: 'Subject'
    },
    {
      sortable: true,
      text: 'Message Body',
      value: 'Message_Body'
    }
  ],
  OppRegRequests: {
    searching: false,
    opportunityId: null,
    showWorkloadForm: false,
    type: 'new'
  },
  upload: {
    File: null,
    fileBase: null,
    filename: null,
    uploadedBy: null,
    AWS_Info_Id: null,
    loading: false,
    dialog: false
  }

}
